import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_V2 } from '../api.conf';
import { Feedback } from '../../models/frontend/feedback';
import { FeedbackPayload } from '../../interfaces';

@Injectable()
export class FeedbackApiService {
  constructor(private http: HttpClient, @Inject(API_V2) private api: string) {}

  private get basePath() {
    return `${this.api}/public`;
  }

  sendFeedback(companyUuid: string, payload: FeedbackPayload): Observable<Feedback> {
    return this.http.put<Feedback>(`${this.basePath}/companies/${companyUuid}/feedbacks`, payload);
  }
}
